import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { TriangleAlert } from 'lucide-react'

import { useAppSelector } from '@/hooks/reduxHooks'

const SETTLED = ['succeeded', 'failed']

export const MissingDocumentsWarning = () => {
  const { t } = useTranslation()

  const activeRodoPolicy = useAppSelector((state) => state.rodoPoliciesDocuments.activeDocument)
  const activeDataProcessing = useAppSelector((state) => state.dataProcessingConsents.activeDocument)
  const policyStatus = useAppSelector((state) => state.rodoPoliciesDocuments.activeDocumentStatus)
  const dataProcessingStatus = useAppSelector((state) => state.dataProcessingConsents.activeDocumentStatus)

  const settled = SETTLED.includes(policyStatus) && SETTLED.includes(dataProcessingStatus)

  if (!settled || (activeRodoPolicy && activeDataProcessing)) return null

  const missing = [
    !activeRodoPolicy ? { key: 'policy', to: '/rodo/privacy-policies', label: t('rodo.privacyPolicies') } : null,
    !activeDataProcessing
      ? { key: 'processing', to: '/rodo/data-processing-consents', label: t('rodo.dataProcessingConsents') }
      : null,
  ].filter(Boolean) as { key: string; to: string; label: string }[]

  return (
    <div
      role='alert'
      className='flex items-start gap-2.5 rounded-crane-md border border-crane-status-alarm/40 bg-crane-status-alarm/10 p-3.5'
    >
      <TriangleAlert className='mt-0.5 size-4 shrink-0 text-crane-status-alarm' aria-hidden />
      <div className='min-w-0 space-y-1'>
        <p className='text-crane-xl font-semibold text-crane-foreground'>{t('rodo.protectionOffTitle')}</p>
        <p className='text-xs text-crane-muted-foreground'>{t('rodo.protectionOffHint')}</p>
        <p className='text-xs text-crane-muted-foreground'>
          {t('rodo.protectionOffMissing')}{' '}
          {missing.map((entry, index) => (
            <span key={entry.key}>
              {index > 0 ? ', ' : ''}
              <Link to={entry.to} className='font-semibold text-crane-primary underline underline-offset-2'>
                {entry.label}
              </Link>
            </span>
          ))}
        </p>
      </div>
    </div>
  )
}
